<template>
  <div>
    <v-container fluid>
      <v-card class="mb-3">
        <v-app-bar color="primary" flat dark dense>
          <v-toolbar-title>Minha Conta</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn
            depressed
            color="primary lighten-4"
            @click="salvar"
            :loading="loadingSalvar"
            :disabled="!formValido"
            >Salvar</v-btn
          >
        </v-app-bar>

        <v-row v-if="loading">
          <v-col
            class="ma-6 pa-6"
            style="display: flex; align-items: center; justify-content: center; text-align: center"
          >
            <v-progress-circular
              size="64"
              indeterminate
              color="primary"
            ></v-progress-circular>
          </v-col>
        </v-row>

        <v-form v-else ref="form" lazy-validation v-model="formValido">
          <v-container fluid class="pa-2">
            <v-row dense v-if="!user.verificado">
              <v-col cols="12" class="px-3">
                <v-alert type="error" prominent text>
                  Caro cliente, precisamos concluir o seu cadastro
                  <br />Por favor, preencha os dados obrigatórios abaixo e
                  clique em SALVAR para poder prosseguir
                </v-alert>
              </v-col>
            </v-row>

            <v-row dense v-if="!cliente.id">
              <v-col cols="12" sm="6" class="px-3">
                <v-text-field
                  label="Razão Social"
                  ref="razao_social"
                  v-model="loja.razao_social"
                  autofocus
                  @keypress.native.enter="$refs.nome_fantasia.focus()"
                  :rules="rulesForm.razao_social"
                  placeholder=" "
                  persistent-placeholder
                  autocomplete="off"
                  role="presentation"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" class="px-3">
                <v-text-field
                  label="Nome Fantasia"
                  ref="nome_fantasia"
                  v-model="loja.nome_fantasia"
                  @keypress.native.enter="$refs.cnpj.focus()"
                  :rules="rulesForm.nome_fantasia"
                  placeholder=" "
                  persistent-placeholder
                  autocomplete="off"
                  role="presentation"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row dense v-if="!cliente.id">
              <v-col cols="12" sm="4" class="px-3">
                <v-text-field
                  label="CNPJ"
                  ref="cnpj"
                  v-model="loja.cnpj"
                  @keypress.native.enter="$refs.ie.focus()"
                  :rules="rulesForm.cnpj"
                  v-mask="'##.###.###/####-##'"
                  :return-masked-value="true"
                  placeholder=" "
                  persistent-placeholder
                  autocomplete="off"
                  role="presentation"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="4" class="px-3">
                <v-text-field
                  label="Inscrição Estadual"
                  ref="ie"
                  v-model="loja.ie"
                  @keypress.native.enter="$refs.rua.focus()"
                  :rules="rulesForm.ie"
                  placeholder=" "
                  persistent-placeholder
                  autocomplete="off"
                  role="presentation"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="4" class="px-3">
                <v-text-field
                  label="Email"
                  ref="email"
                  v-model="cliente.endereco.email"
                  :disabled="!user.verificado || !cliente.id"
                  :rules="rulesForm.email"
                  placeholder=" "
                  persistent-placeholder
                  autocomplete="off"
                  role="presentation"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row dense v-else>
              <v-col cols="12" sm="8" class="px-3">
                <v-text-field
                  label="Nome"
                  ref="nome"
                  autofocus
                  v-model="cliente.nome"
                  @keypress.native.enter="$refs.rua.focus()"
                  :rules="rulesForm.nome_fantasia"
                  placeholder=" "
                  persistent-placeholder
                  autocomplete="off"
                  role="presentation"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="4" class="px-3">
                <v-text-field
                  label="Email"
                  ref="email"
                  v-model="cliente.endereco.email"
                  :disabled="!(!user.verificado || !cliente.id)"
                  :rules="rulesForm.email"
                  placeholder=" "
                  persistent-placeholder
                  autocomplete="off"
                  role="presentation"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row dense>
              <v-col cols="12" sm="6" class="px-3">
                <v-text-field
                  label="Rua"
                  ref="rua"
                  v-model="cliente.endereco.rua"
                  @keypress.native.enter="$refs.numero.focus()"
                  :rules="rulesForm.rua"
                  placeholder=" "
                  persistent-placeholder
                  autocomplete="off"
                  role="presentation"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="2" class="px-3">
                <v-text-field
                  label="Número"
                  ref="numero"
                  v-model="cliente.endereco.numero"
                  @keypress.native.enter="$refs.complemento.focus()"
                  :rules="rulesForm.numero"
                  placeholder=" "
                  persistent-placeholder
                  autocomplete="off"
                  role="presentation"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="4" class="px-3">
                <v-text-field
                  label="Complemento"
                  ref="complemento"
                  v-model="cliente.endereco.complemento"
                  @keypress.native.enter="$refs.bairro.focus()"
                  placeholder=" "
                  persistent-placeholder
                  autocomplete="off"
                  role="presentation"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row dense>
              <v-col cols="12" sm="4" class="px-3">
                <v-text-field
                  label="Bairro"
                  ref="bairro"
                  v-model="cliente.endereco.bairro"
                  @keypress.native.enter="$refs.cep.focus()"
                  :rules="rulesForm.bairro"
                  placeholder=" "
                  persistent-placeholder
                  autocomplete="off"
                  role="presentation"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="2" class="px-3">
                <v-text-field
                  label="CEP"
                  ref="cep"
                  v-model="cliente.endereco.cep"
                  @keypress.native.enter="$refs.estado.focus()"
                  v-mask="'##.###-###'"
                  :return-masked-value="true"
                  :rules="rulesForm.cep"
                  placeholder=" "
                  persistent-placeholder
                  autocomplete="off"
                  role="presentation"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" class="px-3">
                <v-autocomplete
                  v-model="cliente.endereco.estado_id"
                  ref="estado"
                  :items="estados"
                  label="Estado"
                  @change="getCidades"
                  @keypress.native.enter="$refs.cidade.focus()"
                  :rules="rulesForm.estado"
                  placeholder=" "
                  persistent-placeholder
                  autocomplete="off"
                  role="presentation"
                />
              </v-col>
            </v-row>

            <v-row dense>
              <v-col cols="12" sm="6" class="px-3">
                <v-autocomplete
                  v-model="cliente.endereco.cidade_id"
                  ref="cidade"
                  :items="cidades"
                  label="Cidade"
                  @keypress.native.enter="$refs.telefone.focus()"
                  :rules="rulesForm.cidade"
                  :loading="loadingCidades"
                  placeholder=" "
                  persistent-placeholder
                  autocomplete="off"
                  role="presentation"
                />
              </v-col>
              <v-col cols="12" sm="3" class="px-3">
                <v-text-field
                  label="Telefone"
                  ref="telefone"
                  v-model="cliente.endereco.telefone"
                  @keypress.native.enter="$refs.celular.focus()"
                  v-mask="'(##) ####-####'"
                  :return-masked-value="true"
                  :rules="rulesForm.telefone"
                  placeholder=" "
                  persistent-placeholder
                  autocomplete="off"
                  role="presentation"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="3" class="px-3">
                <v-text-field
                  label="Celular"
                  ref="celular"
                  v-model="cliente.endereco.celular"
                  @keypress.native.enter="$refs.responsavel.focus()"
                  v-mask="'(##) #####-####'"
                  :return-masked-value="true"
                  :rules="rulesForm.celular"
                  placeholder=" "
                  persistent-placeholder
                  autocomplete="off"
                  role="presentation"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row dense>
              <v-col cols="12" sm="8" class="px-3">
                <v-text-field
                  label="Nome do Responsável"
                  ref="responsavel"
                  v-model="cliente.responsavel_nome"
                  @keypress.native.enter="$refs.cpf.focus()"
                  :rules="rulesForm.responsavel_nome"
                  placeholder=" "
                  persistent-placeholder
                  autocomplete="off"
                  role="presentation"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="4" class="px-3">
                <v-text-field
                  label="CPF do Responsável"
                  ref="cpf"
                  v-model="cliente.responsavel_cpf"
                  v-mask="'###.###.###-##'"
                  :return-masked-value="true"
                  :rules="rulesForm.responsavel_cpf"
                  @keypress.native.enter="salvar"
                  placeholder=" "
                  persistent-placeholder
                  autocomplete="off"
                  role="presentation"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card>

      <as-dialogo
        ref="dialogoInfoLogin"
        title="Informações para Login"
        max-width="600px"
        hideCloseButton
      >
        <v-label class="text--primary"
          >Seu cadastro foi atualizado com sucesso!</v-label
        >
        <br />
        <br />
        <v-label class="text--primary"
          >A partir de agora, quando for entrar no sistema, você deve utilizar o
          email que você acabou de informar. Sua senha não foi alterada, você
          deve continuar usando a mesma.</v-label
        >
        <br />
        <br />
        <v-label class="text--primary">
          Antigo Login
          <br />
          <v-chip>{{ loginAntigo }}</v-chip>
        </v-label>
        <br />
        <br />
        <v-label class="text--primary">
          Novo Login
          <br />
          <v-chip color="accent" text-color="primary">{{
            cliente.endereco.email
          }}</v-chip>
        </v-label>
        <div class="pt-4" style="display: flex; justify-content: flex-end;">
          <v-btn depressed color="primary" @click="$router.push('/')"
            >Entendi</v-btn
          >
        </div>
      </as-dialogo>
    </v-container>
  </div>
</template>

<script>
import Services from "@/services/services.js";
import ServiceClientes from "@/services/clientes.js";
import validadores from "@/mixins/validadores-mixin";

export default {
  name: "MinhaContaCliente",
  mixins: [validadores],
  data() {
    return {
      loading: false,
      loadingSalvar: false,
      loadingCidades: false,

      estados: Services.estados(),
      cidades: [],

      loginAntigo: "",

      user: {},

      formValido: true,

      cliente: {
        id: "",
        nome: "",
        responsavel_nome: "",
        responsavel_cpf: "",
        representante_id: "",
        endereco_id: "",
        endereco: {
          id: "",
          rua: "",
          numero: "",
          complemento: "",
          bairro: "",
          cidade: "",
          cidade_id: "",
          estado: "",
          estado_id: "",
          cep: "",
          telefone: "",
          celular: "",
          email: "",
        },
        user: {
          email: "",
        },
      },

      loja: {
        razao_social: "",
        nome_fantasia: "",
        cnpj: "",
        ie: "",
        endereco: {
          rua: "",
          numero: "",
          complemento: "",
          bairro: "",
          cidade_id: "",
          estado_id: "",
          cep: "",
          telefone: "",
          celular: "",
          email: "",
        },
      },

      rulesForm: {
        razao_social: [(value) => !!value || "Campo obrigatório"],
        nome_fantasia: [(value) => !!value || "Campo obrigatório"],
        cnpj: [
          (value) => !!value || "Campo obrigatório",
          (value) => this.validarCNPJ(value) || "CNPJ Inválido",
        ],
        nome: [(value) => !!value || "Campo obrigatório"],
        responsavel_nome: [(value) => !!value || "Campo obrigatório"],
        responsavel_cpf: [
          (value) => (value ? this.validarCPF(value) || "CPF Inválido" : true),
          (value) => !!value || "Campo obrigatório",
        ],
        representante: [(value) => !!value || "Campo obrigatório"],
        rua: [(value) => !!value || "Campo obrigatório"],
        numero: [(value) => !!value || "Campo obrigatório"],
        bairro: [(value) => !!value || "Campo obrigatório"],
        cidade: [(value) => !!value || "Campo obrigatório"],
        estado: [(value) => !!value || "Campo obrigatório"],
        cep: [(value) => !!value || "Campo obrigatório"],
        telefone: [
          (value) => (!!value && !this.cliente.celular) || "Campo obrigatório",
        ],
        celular: [
          (value) => (!!value && !this.cliente.telefone) || "Campo obrigatório",
        ],
        email: [
          (value) =>
            value ? this.validarEmail(value) || "Email Inválido" : true,
          (value) => !!value || "Campo obrigatório",
        ],
      },
    };
  },

  mounted() {
    this.user = JSON.parse(localStorage.getItem("user"));
    this.listar();
  },

  methods: {
    async listar() {
      try {
        this.loading = true;

        let response = await ServiceClientes.index(this.user.cliente_id);
        this.cliente = response.data.cliente;

        await this.getCidades();
      } catch (error) {
        this.$eventbus.erro(
          "Não foi possível carregar os dados da conta",
          error
        );
      } finally {
        this.loading = false;
      }
    },

    async salvar() {
      if (this.$refs.form.validate()) {
        if (!this.user.verificado && !this.cliente.id) {
          this.loja.endereco = { ...this.cliente.endereco };
          delete this.loja.endereco.cidade;
          delete this.loja.endereco.estado;

          this.cliente.nome = this.loja.nome_fantasia;
        }

        try {
          this.loadingSalvar = true;
          this.cliente.loja = this.loja;
          let response = await ServiceClientes.salvarConfig(this.cliente);
          localStorage.setItem("user", JSON.stringify(response.data.user));

          // Loja criada na ativação do novo cliente
          if (!this.user.verificado && !this.cliente.id) {
            await ServiceClientes.salvarLoja(
              response.data.user.cliente_id,
              this.loja
            );
          }

          if (this.cliente.novo_cadastro) {
            if (this.$store.state.produtos.length > 0) {
              this.$router.push("/checkout");
            } else {
              this.$router.push("/");
            }
          } else {
            if (this.user.verificado) {
              this.$router.go(-1);
            } else {
              this.loginAntigo = this.user.email;
              localStorage.setItem("user", JSON.stringify(response.data.user));
              this.$refs.dialogoInfoLogin.abrir();
            }
          }
          this.$eventbus.notificar("Dados da conta salvos com sucesso");
        } catch (error) {
          this.$eventbus.erro(
            error.response?.data?.message ||
              error.response?.data?.msg ||
              "Erro ao salvar os dados",
            error
          );
        } finally {
          this.loadingSalvar = false;
        }
      }
    },

    async getCidades() {
      try {
        this.loadingCidades = true;
        let response = await Services.cidades(this.cliente.endereco.estado_id);
        this.cidades = response.data.cidades;
      } catch (error) {
        console.log(error);
        this.$eventbus.erro("Erro ao buscar cidades");
      } finally {
        this.loadingCidades = false;
      }
    },
  },
};
</script>
